import { create } from "zustand";
import { IMemberGridFilter } from "../api_1/types";
import { GridPaginationModel, GridSortModel } from "@mui/x-data-grid";
import { PostModel } from "common/models/baseModel";

export interface MemberStore {
  postModel: PostModel<IMemberGridFilter>;
  handleFiltering: (filter: IMemberGridFilter) => void;
  handlePagination: (pageModel: GridPaginationModel) => void;
  handleSorting: (sortModel: GridSortModel) => void;
}

const useMemberStore = create<MemberStore>()((set) => ({
  postModel: {
    pagingModel: {
      page: 0,
      pageSize: 100,
    },
    filterModel: {
      year: null,
      birthDate: null,
      cityName: null,
      countryID: null,
      courseID: null,
      email: null,
      enrollmentNo: null,
      gender: null,
      universityID: null,
      industryID: null,
      instituteID: null,
      memberName: null,
      memberStatus: null,
      programID: null,
      pinCode: null,
      specializationID: null,
      stateID: null,
      toYear: null,
      company: null,
      designation: null,
      professionType: null,
      skills: [],
      skillsValue: { id: "", name: "" },
      industries: [],
      industriesValue: { id: "", name: "" },
    },
  },
  handlePagination: (pageModel: GridPaginationModel) =>
    set((state) => ({
      postModel: { ...state.postModel, pagingModel: { ...pageModel } },
    })),
  handleFiltering: (filterModel: IMemberGridFilter) =>
    set((state) => ({
      postModel: { ...state.postModel, filterModel: { ...filterModel } },
    })),
  handleSorting: (sortModel: GridSortModel) =>
    set((state) => ({
      postModel: { ...state.postModel, sortModel: [...sortModel] },
    })),
}));

export default useMemberStore;
